const icons = [
  { name: '系统设置', url: require('./系统设置.svg') },
  { name: 'Cmdb', url: require('./Cmdb.svg') },
  { name: 'Node', url: require('./Node.svg') },
  { name: 'User', url: require('./User.svg') },
  { name: 'Role', url: require('./Role.svg') },
  { name: 'Department', url: require('./Department.svg'), },
  { name: 'License', url: require('./License.svg') },
  { name: 'Log', url: require('./Log.svg') },
  { name: 'Table', url: require('./Table.svg') },
  { name: 'DataView', url: require('./DataView.svg') },
  { name: 'Users', url: require('./Users.svg') },
  { name: 'OnlineEdit', url: require('./OnlineEdit.svg') },
  { name: '系统操作', url: require('./系统操作.svg') },
  { name: '系统主题', url: require('./theme.svg') },
  { name: 'applications', url: require('./Test.svg') },
  { name: 'Debug', url: require('./Debug.svg') },
  { name: 'Docker', url: require('./Docker.svg') },
  { name: 'Event', url: require('./Event.svg') },
  { name: 'Gateway', url: require('./Gateway.svg') },
  { name: 'Message', url: require('./Message.svg') },
  { name: 'Report', url: require('./Report.svg') },
  { name: 'Help', url: require('./homeIcon/帮助中心.svg') },
  { name: 'Analysis', url: require('./Analysis.svg') },


]

export default {
  name: 'iot.icon',
  items: {
    icons: { type: 'array' }
  },
  icons
}
